var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#5B47F5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_717_20169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0904 6V10.5C15.0904 11.05 14.6404 11.5 14.0904 11.5H10.7604C10.2104 11.5 9.76041 11.05 9.76041 10.5V6C9.76041 5.45 10.2104 5 10.7604 5H14.0904C14.6404 5 15.0904 5.45 15.0904 6ZM17.0904 11.5H20.4204C20.9704 11.5 21.4204 11.05 21.4204 10.5V6C21.4204 5.45 20.9704 5 20.4204 5H17.0904C16.5404 5 16.0904 5.45 16.0904 6V10.5C16.0904 11.05 16.5304 11.5 17.0904 11.5ZM15.0904 18V13.5C15.0904 12.95 14.6404 12.5 14.0904 12.5H10.7604C10.2104 12.5 9.76041 12.95 9.76041 13.5V18C9.76041 18.55 10.2104 19 10.7604 19H14.0904C14.6404 19 15.0904 18.55 15.0904 18ZM16.0904 13.5V18C16.0904 18.55 16.5404 19 17.0904 19H20.4204C20.9704 19 21.4204 18.55 21.4204 18V13.5C21.4204 12.95 20.9704 12.5 20.4204 12.5H17.0904C16.5304 12.5 16.0904 12.95 16.0904 13.5ZM7.75041 12.5H4.42041C3.87041 12.5 3.42041 12.95 3.42041 13.5V18C3.42041 18.55 3.87041 19 4.42041 19H7.75041C8.30041 19 8.75041 18.55 8.75041 18V13.5C8.75041 12.95 8.31041 12.5 7.75041 12.5ZM8.75041 10.5V6C8.75041 5.45 8.30041 5 7.75041 5H4.42041C3.87041 5 3.42041 5.45 3.42041 6V10.5C3.42041 11.05 3.87041 11.5 4.42041 11.5H7.75041C8.31041 11.5 8.75041 11.05 8.75041 10.5Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_717_20169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.42041)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridview);
export default __webpack_public_path__ + "static/media/gridview.1bcb2a64608aa79b442b4735b5414ba3.svg";
export { ForwardRef as ReactComponent };